import React, { FC } from "react";

interface ImpactType {
    impactContent: Array<string>;
}
const Impact: FC<ImpactType> = ({ impactContent }) => {
    return (
        <section className="my-9">
            <h2 className="casestudy-header text-blue-color">Impact Created by Gallabox:</h2>
            <ul className={impactContent.length === 1 ? "pl-0" : ""}>
                {impactContent.map((item) => {
                    return <div key={item} dangerouslySetInnerHTML={{ __html: item }} />;
                })}
            </ul>
        </section>
    );
};

export default Impact;
